export default "__VITE_ASSET__C_WalCiF__"